import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {AuthConsumer} from '../../utils/AuthContext';
import {isEmpty} from "../../utils/Utilities";
import PropTypes from "prop-types";
import MainDashboardPage from "../../pages/MainDashboardPage";
import AuthPage from "../../pages/AuthPage";
import OutgoingDashboardPage from "../../pages/OutgoingDashboardPage";


function render(rootMenu, isAuth, user, Component, Layout, props) {
    if(isAuth){
        rootMenu = isEmpty(rootMenu)?"/":rootMenu
        // console.log("####MENU = "+rootMenu)
        let menu = props.path
        let userRole = user.userRole?user.userRole:{}
        let treeMenus = userRole.treeMenus?userRole.treeMenus:[]
        let memberMenus = []
        treeMenus.forEach(value => {
            memberMenus.push(value.link)
            let subChildMenus = value.childMenus?value.childMenus:[]
            subChildMenus.forEach(value1 => {
                memberMenus.push(value1.link)
            })
        })
        let accessible = false ;

        let dashboardIsAccessible = false ;
        let outgoingIsAccessible = false ;
        memberMenus.forEach(value => {
            if(value===MainDashboardPage.ENDPOINT){
                dashboardIsAccessible = true ;
            }
            if(value===OutgoingDashboardPage.ENDPOINT){
                outgoingIsAccessible = true ;
            }
        })

        if(rootMenu==="*"){
            accessible = true
        }else{
            memberMenus.forEach(value => {
                if(value===rootMenu){
                    accessible = true
                }
            })
        }
        let basePage = MainDashboardPage.ENDPOINT
        if(dashboardIsAccessible){
            basePage = MainDashboardPage.ENDPOINT
        }else if(outgoingIsAccessible){
            basePage = OutgoingDashboardPage.ENDPOINT
        }
        if(accessible){
            return (
                <Layout {...props}>
                    <Component {...props} query={props.location.search} />
                </Layout>
            )
        }else{
            // return (<Redirect to={MainDashboardPage.ENDPOINT} />)
            return (<Redirect to={basePage} />)
        }

    }else{
        return (<Redirect to={AuthPage.ENDPOINT} />)
    }
    return isAuth
}

const ProtectedRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <AuthConsumer>
        {({ isAuth, user }) => (
            <Route
                render={props =>
                    render(rest.rootMenu, isAuth, user, Component, Layout, props)
                }
                {...rest}
            />
        )}
    </AuthConsumer>
)

ProtectedRoute.propTypes = {
    rootMenu : PropTypes.string.isRequired
}

export default ProtectedRoute
